import React from "react"
import Main from "../elements/Main"

function Header() {
    return(
        <header>
            <Main />
        </header>
    )
}

export default Header